import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { changeHistory } from 'actions/livefeed/historyActions'

const ReUnDoButton = (props) => {
    const { stepNumberState, historyLength, dispatch, editorView } = props;

    const isUndoable = stepNumberState > 0;
    const isRedoable = (stepNumberState >= 0 && stepNumberState < historyLength - 1)
    // ----------------------- Redo/Undo keys hanlde ---------------------
    useEffect(() => {
        const keyHandlerReUnDo = function (event) {

            if (event.ctrlKey && event.key === "z") {
                handleUnRedo("undo")
            } else if (event.ctrlKey && event.key === "y") {
                handleUnRedo("redo")
            }
            // for mac
            if (event.metaKey && event.shiftKey && event.key === "z") {
                handleUnRedo("redo")
            }
            else if (event.metaKey && event.key === "z") {
                handleUnRedo("undo")
            }
        }
        window.addEventListener("keydown", keyHandlerReUnDo);
        return () => {
            window.removeEventListener("keydown", keyHandlerReUnDo)
        }
    }, [dispatch, isRedoable, isUndoable, handleUnRedo, stepNumberState])

    const handleUnRedo = useCallback((mode) => {
        switch (mode) {
            case "undo":
                isUndoable && dispatch(changeHistory(stepNumberState - 1));
                break;
            case "redo":
                isRedoable && dispatch(changeHistory(stepNumberState + 1));
                break;
            default:
        }
    }, [dispatch, isRedoable, isUndoable, stepNumberState])

    return (
        <React.Fragment>
            <div className={`icon-wrapper justify-center ${isUndoable && editorView ? '' : 'icon-wrapper_disable'}`} onClick={() => editorView ? handleUnRedo("undo") : null}>
                <i style={{ fontSize: "24px" }} data-tooltip={'Undo'} className="material-icons">undo</i>
            </div>

            <div className={`icon-wrapper justify-center ${isRedoable && editorView ? '' : 'icon-wrapper_disable'}`} onClick={() => editorView ? handleUnRedo("redo") : null}>
                <i style={{ fontSize: "24px" }} data-tooltip={'Redo'} className="material-icons">redo</i>
            </div>
        </React.Fragment>
    );
}
ReUnDoButton.propTypes = {
    dispatch: PropTypes.func.isRequired,
    historyLength: PropTypes.number.isRequired,
    editorView: PropTypes.bool.isRequired,
    stepNumberState: PropTypes.number.isRequired
}
export default ReUnDoButton;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/ReUnDoButton.jsx